"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "@/components/ui/Link";
import { MessageIcon } from "../ui/message-icon";
import { Frame } from "@/components/ui/frame";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getTimeAgo, getFocusPointStyle, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string;
  customClass?: string;
};
type Props = {
  category?: FieldConfig;
  title?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  className?: string;
  slug?: string;
  /** Mark as LCP image - preloads for faster rendering */
  priority?: boolean;
  imageMetadata?: ImageMetadata;
};
export const VerticalBigImagesNewsWhite = t0 => {
  const $ = _c(40);
  const {
    title: t1,
    timeAgo: t2,
    imageSrc: t3,
    slug,
    priority: t4,
    imageMetadata
  } = t0;
  let t5;
  if ($[0] !== t1) {
    t5 = t1 === undefined ? {
      hidden: false,
      value: "\u0BB7\u0BBE\u0BB2\u0BBF\u0BA9\u0BBF \u0BAE\u0BB1\u0BCD\u0BB1\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB4\u0BA8\u0BCD\u0BA4\u0BC8\u0B95\u0BB3\u0BCD \u0B85\u0BA9\u0BC1\u0BB7\u0BCD\u0B95\u0BBE, \u0B86\u0BA4\u0BCD\u0BB5\u0BBF\u0B95\u0BCD \u0B86\u0B95\u0BBF\u0BAF\u0BCB\u0BB0\u0BCD \u0BB7\u0BBE\u0BAE\u0BCD\u0BB2\u0BBF \u0B95\u0BB2\u0BC8\u0B95\u0BCD \u0B95\u0BA3\u0BCD\u0B95\u0BBE\u0B9F\u0BCD\u0B9A\u0BBF\u0BAF\u0BBF\u0BB2\u0BCD \u0B95\u0BB2\u0BA8\u0BCD\u0BA4\u0BC1 \u0B95\u0BCA\u0BA3\u0BCD\u0B9F\u0BA9\u0BB0\u0BCD",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const title = t5;
  let t6;
  if ($[2] !== t2) {
    t6 = t2 === undefined ? {
      hidden: false,
      value: "Wed, 17May 2023",
      customClass: ""
    } : t2;
    $[2] = t2;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  const timeAgo = t6;
  let t7;
  if ($[4] !== t3) {
    t7 = t3 === undefined ? {
      hidden: false,
      value: FALLBACK_IMAGE,
      customClass: ""
    } : t3;
    $[4] = t3;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const imageSrc = t7;
  const priority = t4 === undefined ? false : t4;
  const titleValue = title?.value || "";
  const t8 = timeAgo?.value;
  let t9;
  if ($[6] !== t8) {
    t9 = getTimeAgo(t8);
    $[6] = t8;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  const timeAgoValue = t9;
  let t10;
  if ($[8] !== imageSrc?.value) {
    t10 = getImageUrl(imageSrc?.value) || FALLBACK_IMAGE;
    $[8] = imageSrc?.value;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  const imageSrcValue = t10;
  let t11;
  if ($[10] !== imageMetadata || $[11] !== imageSrc?.customClass || $[12] !== imageSrc?.hidden || $[13] !== imageSrcValue || $[14] !== priority || $[15] !== titleValue) {
    t11 = !imageSrc?.hidden && <div className={imageSrc?.customClass || ""}><div className="relative w-full h-[431px] overflow-hidden"><Image src={imageSrcValue} alt={titleValue} fill={true} priority={priority} className="object-cover" style={getFocusPointStyle(imageMetadata)} loading={priority ? "eager" : "lazy"} fetchPriority={priority ? "high" : "auto"} placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div></div>;
    $[10] = imageMetadata;
    $[11] = imageSrc?.customClass;
    $[12] = imageSrc?.hidden;
    $[13] = imageSrcValue;
    $[14] = priority;
    $[15] = titleValue;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== title?.customClass || $[18] !== title?.hidden || $[19] !== titleValue) {
    t12 = !title?.hidden && <h3 className={`text-18-tamil-700 min-h-auto md:text-18-tamil-700 lg:text-18-tamil-700 text-FFFFFF leading-[1.4] line-clamp-2 whitespace-pre-line ${title?.customClass || ""}`}>{titleValue}</h3>;
    $[17] = title?.customClass;
    $[18] = title?.hidden;
    $[19] = titleValue;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== timeAgo?.customClass || $[22] !== timeAgo?.hidden || $[23] !== timeAgoValue) {
    t13 = !timeAgo?.hidden && <span className={`text-12-tamil-500 ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>;
    $[21] = timeAgo?.customClass;
    $[22] = timeAgo?.hidden;
    $[23] = timeAgoValue;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  const t14 = slug ? `/${slug}` : undefined;
  let t15;
  if ($[25] !== imageSrcValue || $[26] !== slug || $[27] !== t14 || $[28] !== titleValue) {
    t15 = <div className="flex gap-3"><MessageIcon id="small-image-news-vert-message-icon" variant="message-icon-4" slug={slug} category={BOOKMARK_CATEGORIES.PHOTOS} title={titleValue} thumbnailUrl={imageSrcValue} articleUrl={t14} /></div>;
    $[25] = imageSrcValue;
    $[26] = slug;
    $[27] = t14;
    $[28] = titleValue;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t13 || $[31] !== t15) {
    t16 = <div className="flex justify-between items-center text-FFFFFF gap-2">{t13}{t15}</div>;
    $[30] = t13;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t11 || $[34] !== t12 || $[35] !== t16) {
    t17 = <div className="flex flex-col overflow-hidden p-4 gap-4">{t11}{t12}{t16}</div>;
    $[33] = t11;
    $[34] = t12;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  const content = t17;
  if (slug) {
    const t18 = `/${slug}`;
    let t19;
    if ($[37] !== content || $[38] !== t18) {
      t19 = <Link href={t18} className="block hover:opacity-90 transition-opacity cursor-pointer">{content}</Link>;
      $[37] = content;
      $[38] = t18;
      $[39] = t19;
    } else {
      t19 = $[39];
    }
    return t19;
  }
  return content;
};